/**
 * MessagingPrefsSection — 149-cc. Collapsible section di ProfileDialog Preferensi.
 * Toggle Notifikasi Pesan, Suara Notifikasi, Jangan Ganggu (DND). Server-side sync
 * via `/messaging/prefs` — sinkron antar device.
 */
import { toast } from "sonner";
import { MessageSquare, BellOff, Volume2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import useMessagingPrefs from "@/hooks/useMessagingPrefs";
import { formatDetail } from "@/lib/api";

export default function MessagingPrefsSection({ open }) {
  const { prefs, loaded, update } = useMessagingPrefs(open);

  const toggle = async (key, next) => {
    try { await update({ [key]: next }); }
    catch (e) { toast.error(formatDetail(e.response?.data?.detail) || "Gagal simpan preferensi"); }
  };

  if (!loaded) return <div className="text-[11px] italic text-slate-400 px-3 py-4 text-center">Memuat preferensi pesan…</div>;

  const rows = [
    { key: "notif", label: "Notifikasi Pesan Masuk", icon: MessageSquare, description: "Tampilkan badge unread + push realtime saat ada pesan baru." },
    { key: "sound", label: "Suara Notifikasi", icon: Volume2, description: "Bunyikan beep singkat saat pesan baru tiba. Otomatis mati saat DND." },
    { key: "dnd", label: "Jangan Ganggu (DND)", icon: BellOff, description: "Sembunyikan suara & tetap terima pesan diam-diam. Badge tetap update." },
  ];

  return (
    <div className="border border-slate-200" data-testid="msg-prefs-panel">
      <ul className="divide-y divide-slate-100">
        {rows.map((r) => {
          const on = !!prefs[r.key];
          const Icon = r.icon;
          const tone = r.key === "dnd" ? (on ? "text-amber-600" : "text-slate-400") : (on ? "text-emerald-600" : "text-slate-400");
          return (
            <li key={r.key} className="flex items-center justify-between gap-3 px-3 py-2.5 hover:bg-slate-50" data-testid={`msg-pref-row-${r.key}`}>
              <div className="flex items-start gap-2 min-w-0">
                <Icon size={13} className={`shrink-0 mt-0.5 ${tone}`} />
                <div className="min-w-0">
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-[#0B1D3A]">{r.label}</div>
                  <div className="text-[10px] text-slate-500 leading-snug mt-0.5">{r.description}</div>
                </div>
              </div>
              <Switch checked={on} onCheckedChange={(v) => toggle(r.key, v)}
                data-testid={`msg-pref-toggle-${r.key}`} aria-label={`Toggle ${r.label}`} />
            </li>
          );
        })}
      </ul>
      <div className="px-3 py-1.5 text-[9px] italic text-slate-400 bg-slate-50 border-t border-slate-200">
        Preferensi ini disimpan di akun Anda dan otomatis sinkron ke semua device saat login.
      </div>
    </div>
  );
}
